import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { SdvorSharedCmsComponents } from '../cms-components.enum';

@NgModule({
  imports: [
    ConfigModule.withConfig({
      featureModules: {
        spoilerContainer: {
          module: () => import('./spoiler-container-lazy.module').then((m) => m.SpoilerContainerLazyModule),
          cmsComponents: [SdvorSharedCmsComponents.RosaSpoilerContainerComponent],
        },
      },
    }),
  ],
})
export class SpoilerContainerModule {}
